export const GET_RENTER_ORDER_DETAILS = "GET_RENTER_ORDER_DETAILS"
export const GET_RENTER_ORDER_DETAILS_SUCCESSFUL = "GET_RENTER_ORDER_DETAILS_SUCCESSFUL"
export const GET_RENTER_ORDER_DETAILS_FAILED = "GET_RENTER_ORDER_DETAILS_FAILED"
